import type { AnalyticsReportData } from '../types'
import { extractPrimitiveValue } from './extractPrimitiveValue'

type GetSummaryValueParams = {
  reportData: AnalyticsReportData | undefined
  columnKey: string | undefined
}

export const getSummaryValue = ({
  reportData,
  columnKey,
}: GetSummaryValueParams): number | undefined => {
  if (!reportData || !columnKey) return undefined

  const summary = reportData.report.summary as AnalyticsReportData['report']['summary']
  if (!summary || !(columnKey in summary)) return undefined

  const summaryValue = summary[columnKey]
  const primitiveValue = extractPrimitiveValue(summaryValue)

  return typeof primitiveValue === 'number' ? primitiveValue : 0
}
